import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.js';
import { getUiLanguage } from './Utils/uiLocale.js';

// LanguageProvider sets these after its first render; setting them now from the saved
// language means an error on first load (root ErrorBoundary) still shows right-to-left for RTL UIs.
const initialLanguage = getUiLanguage();
document.documentElement.lang = initialLanguage;
document.documentElement.dir = ['ar', 'fa'].includes(initialLanguage) ? 'rtl' : 'ltr';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>
);
